import { Emdash } from "../Punctuation";
import { GridDollarSign } from "./GridDollarSign";

// // // //

/**
 * DataGridDollarValue
 * Render a dollar value in DataGridCell
 */
export function DataGridDollarValue(props: {
    value: number;
    decimalPlaces?: number;
}) {
    const { value, decimalPlaces = 0 } = props;
    if (typeof value !== "number") {
        return <Emdash />;
    }

    if (value === 0 || Math.abs(value) < 0.0001) {
        if (value < 0) {
            return <Emdash />;
        }
        return (
            <>
                <GridDollarSign />
                {Math.abs(value).toFixed(0)}
            </>
        );
    }

    if (Math.abs(value) < 100) {
        return (
            <>
                <GridDollarSign />
                {value.toFixed(decimalPlaces)}
            </>
        );
    }

    return (
        <>
            <GridDollarSign />
            {Math.round(value).toLocaleString()}
        </>
    );
}
